/**
 * Friendly «ikke tilgjengelig» state when StatusUpdate APIs are undeployed/missing.
 * Must not crash the surrounding page (home, subject tabs, Mine oppdateringer).
 */
import React from "react";
import { useTranslation } from "react-i18next";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

export function StatusUpdateUnavailableNotice({
  compact = false,
  className = "",
  onRetry = null,
  retrying = false,
}) {
  const { t } = useTranslation();

  return (
    <div
      role="status"
      className={[
        "rounded-xl border border-amber-200 bg-amber-50 text-amber-950",
        compact ? "px-3 py-2.5" : "px-4 py-3",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <div className="flex items-start gap-2.5">
        <ExclamationTriangleIcon
          className={compact ? "mt-0.5 h-5 w-5 shrink-0 text-amber-600" : "mt-0.5 h-6 w-6 shrink-0 text-amber-600"}
          aria-hidden="true"
        />
        <div className="min-w-0">
          <p className={compact ? "text-sm font-semibold" : "text-sm font-semibold sm:text-base"}>
            {t("status_update.unavailable_title")}
          </p>
          <p className={compact ? "mt-0.5 text-xs text-amber-900/80" : "mt-1 text-sm text-amber-900/80"}>
            {t("status_update.unavailable_description")}
          </p>
          {typeof onRetry === "function" ? (
            <button
              type="button"
              onClick={onRetry}
              disabled={retrying}
              className="mt-2 text-sm font-semibold text-[#0B3A78] underline-offset-2 hover:underline disabled:cursor-not-allowed disabled:opacity-60"
            >
              {retrying ? `${t("status_update.retry")}…` : t("status_update.retry")}
            </button>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default StatusUpdateUnavailableNotice;
